import { ref, onMounted } from 'vue';
import { useAppStore } from "@/store/app";
import { allModalsVariant } from "@/config/allModals.ts";
import type { AllModalsVariantType } from "@/config/allModals.ts";

export function useAppLogic() {
  const appStore = useAppStore();
  const userData = ref<any>(null);

  onMounted(async () => {
    initApp();
  });

  const initApp = async () => {
    addEventListenerMessage();
    const urlParams = new URLSearchParams(globalThis.location.search);
    const variant = getModalVariant(urlParams);
    const complaintCode = urlParams.get("code") || "";

    if (complaintCode) {
      appStore.setComplaintCode(complaintCode);
    }

    if (variant) {
      showModalFromUrl(variant);
    }
  };

  const getVariantType = (variant: AllModalsVariantType) => {
    return allModalsVariant[variant];
  };

  const addEventListenerMessage = () => {
    window.addEventListener("message", async (event) => {
      let actionType = '';
      const modalVariant = event?.data?.modalVariant;

      if(event.data.sender === "dsa_widget"){
        appStore.setReportCommentID(event.data.commentsID);
        appStore.setOverlayVisible(true);
        actionType = getVariantType(modalVariant);

        if (actionType === "dsa_form") {
          appStore.setFormVisibility(true);
        } else if (actionType === "dsa_modal") {
          const modalData = {
              show: true,
              modalVariant: modalVariant || '',
              commentsID: event.data.commentsID || '',
              errorMessage: '',
          }
          appStore.setModalData(modalData);
          appStore.setFormVisibility(false);
        } else if (actionType === "dsa_action") {
          appStore.setActionFormVisible(true);
          appStore.setActionFormVariant(modalVariant || '');
        }
      }
    });
  };
  
  const showModalFromUrl = (variant: string) => {
    const modalData = {
      show: true,
      modalVariant: variant,
      commentsID: '',
      errorMessage: '',
    }
    appStore.setInputDataSource("url");
    appStore.setModalData(modalData);
    appStore.setOverlayVisible(true);
  }

  const getModalVariant = (urlParams: URLSearchParams) => {
    let variant = urlParams.get("dsa_modal") || '';
    const isCorrectVariant = checkVariant(variant);

    if (!isCorrectVariant) {
      variant = '';
    } 

    return variant;
  };
  
  const checkVariant = (variant: string | null) => {
    const allVariants = [
      "thankYou_notEmail",
      "thankYou_haveEmail",
      "confirm_mail",
      "already_confirmed",
      "link_expired",
      "already_submit",
      "complaint_form",
      "complaint_thankYou",
      "complaint_confirmed",
      "complaint_expired",
      "something_wrong",
      "something_wrong_mail",
      "tresc_usunieta",
      "tresc_ukryta",   
    ];

    return !!(variant && allVariants.includes(variant));
  };

  return {
    getModalVariant,
    checkVariant,
    userData,
    showModalFromUrl,
    addEventListenerMessage,
    initApp
  };
}
